import { createStore } from 'ice';
import user from '@/models/user';
import spaceRole from '@/models/spaceRole';
import siteSettings from '@/models/siteSettings'
import policy from './models/policy';

export default createStore({
  user,
  spaceRole,
  siteSettings,
  policy,
});
